import { render } from "./App.vue?vue&type=template&id=37152041&bindings={\"board\":\"data\",\"boardPieceToUpdateNum\":\"data\",\"solveSection\":\"data\",\"solved\":\"data\",\"resetBoard\":\"options\",\"solveBoard\":\"options\",\"makeEmptyBoard\":\"options\",\"updateBoardVal\":\"options\",\"invalidCheck\":\"options\",\"invalidSolve\":\"options\",\"dragNum\":\"options\",\"removeHoverHighlight\":\"options\",\"dragBoard\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script